import React from "react";

const UserInfo = ({color}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="27"
      viewBox="0 0 25 27"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.8333 2.66667H16.26C15.7 1.12 14.2333 0 12.5 0C10.7667 0 9.3 1.12 8.74 2.66667H3.16667C1.7 2.66667 0.5 3.86667 0.5 5.33333V24C0.5 25.4667 1.7 26.6667 3.16667 26.6667H21.8333C23.3 26.6667 24.5 25.4667 24.5 24V5.33333C24.5 3.86667 23.3 2.66667 21.8333 2.66667ZM12.5 2.33333C12.7933 2.33333 13.0467 2.46667 13.2333 2.66667C13.3933 2.84 13.5 3.08 13.5 3.33333C13.5 3.88 13.0467 4.33333 12.5 4.33333C11.9533 4.33333 11.5 3.88 11.5 3.33333C11.5 3.08 11.6067 2.84 11.7667 2.66667C11.9533 2.46667 12.2067 2.33333 12.5 2.33333ZM3.16667 5.33333V24H21.8333V5.33333H3.16667ZM12.5 6.66667C10.3 6.66667 8.5 8.46667 8.5 10.6667C8.5 12.8667 10.3 14.6667 12.5 14.6667C14.7 14.6667 16.5 12.8667 16.5 10.6667C16.5 8.46667 14.7 6.66667 12.5 6.66667ZM11.1667 10.6667C11.1667 11.4 11.7667 12 12.5 12C13.2333 12 13.8333 11.4 13.8333 10.6667C13.8333 9.93333 13.2333 9.33333 12.5 9.33333C11.7667 9.33333 11.1667 9.93333 11.1667 10.6667ZM4.5 20.6267V22.6667H20.5V20.6267C20.5 17.2933 15.2067 15.8533 12.5 15.8533C9.79333 15.8533 4.5 17.28 4.5 20.6267ZM12.5 18.5067C10.7533 18.5067 8.5 19.2533 7.58 20H17.42C16.5133 19.2533 14.2467 18.5067 12.5 18.5067Z"
        fill={color}
      />
    </svg>
  );
};

export default UserInfo;
